import { useMemo } from 'react';
import { useCollectionItem, useLiveQuery } from '@rocketlane/state-db';
import { taskCollection } from './task-collection';
import { apiTaskToStoreTask } from './to-store';
/**
 * Read a single task (api shape) from the collection. Re-renders only when
 * that task changes. Use for detail/pane views that consume the api shape.
 */ export const useTask = (taskId)=>useCollectionItem(taskCollection, taskId);
/**
 * Read a single task in STORE shape (flattened fields, project as number) for
 * AgGrid rows and legacy components. `fieldLookup` flattens custom fields.
 */ export const useTaskStoreShape = (taskId, fieldLookup, tasksLookup = {})=>{
    const task = useCollectionItem(taskCollection, taskId);
    return useMemo(()=>task ? apiTaskToStoreTask(task, fieldLookup, tasksLookup) : undefined, [
        task,
        fieldLookup,
        tasksLookup
    ]);
};
/**
 * Reactive list of a project's tasks (api shape) from the collection.
 * Re-renders when any task in the project changes.
 */ export const useProjectTasks = (projectId)=>useLiveQuery(taskCollection, (all)=>all.filter((task)=>{
            var _task_project;
            return ((_task_project = task.project) === null || _task_project === void 0 ? void 0 : _task_project.projectId) === projectId;
        }), [
        projectId
    ]);
